//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
import guid from "./../factories/guid";
import Bao from "./../services/bao-service";
import BaoDialog from "../factories/bao-dialog";
import TakePictureDialog from "../checkware/view-models/dialogs/take-picture-dialog";
import takePictureDialogTemplate from "../checkware/factories/take-picture-dialog-template.html";
import * as moment from "moment";


var bindingName = "baoUpload";
export class BaoUploadBinding {
    constructor(element: HTMLElement, valueAccessor: () => Bindings.baoUpload, allBindingsAccessor?: any, viewModel?: any) {
        this.Element = element;
        this.Config = valueAccessor();
        this.AllBindingsAccessor = allBindingsAccessor;
        this.ViewModel = viewModel;
        if (ko.unwrap(this.Config.MultiUpload)) {
            this.MultiUpload = ko.unwrap(this.Config.MultiUpload);
        }
        this.FileNameObservable = this.Config.FileName;

        $(this.Element).data(bindingName, this);
        Bao.post("UploadSettings/GetUploadMessages").then((messages) => {
            this._messagesDictionary = messages;
        });
        this._initControl();
        this.CheckEnable();

        //subscribes
        if (ko.isObservable(this.Config.Enabled)) {
            this._subscribes.push((<KnockoutObservable<boolean>>this.Config.Enabled).subscribe(() => {
                this.CheckEnable();
            }));
        }
    }

    FileNameObservable: KnockoutObservable<string>;
    Element: HTMLElement;
    AllBindingsAccessor: any;
    ViewModel: any;
    Config: Bindings.baoUpload;
    MultiUpload: boolean = false;

    private _subscribes: KnockoutSubscription[] = [];
    private _$iframe: JQuery;
    private _$fileupload: JQuery;
    private _$uploadForm: JQuery;
    private _$removeButton: JQuery;
    private _$photoButton: JQuery;
    private _uploadNeeded = false;
    private _isPictureUpload: boolean = false;
    private _base64Image: string;
    private _pictureFormData: FormData;
    private _maxUploadSize = 0;
    private _messagesDictionary = {};


    private _initControl() {
        $(this.Element).attr("readonly", "readonly");

        //form erstellen        
        var $searchButton = $('<span class="input-group-btn"><button class="btn btn-default"><span class="fal fa-search"></span></button></span>');
        this._$removeButton = $('<span class="input-group-btn"><button class="btn btn-default"><span class="fal fa-trash-alt"></span></button></span>');

        var iframeId = guid();
        var $submitButton = $("<input type='submit' value='Submit'>").hide();
        this._$fileupload = $("<input class='fakeupload' type='file' name='" + guid() + "' />").prop("multiple", this.MultiUpload);
        this._$iframe = $("<iframe src=''></iframe>").attr("name", iframeId).attr("width", "0").attr("height", "0").attr("border", "0").attr("style", "width: 0; height: 0; border: none;");

        $(document.body).append(this._$iframe);
        $(this.Element).wrap("<div class='baoSearcher'></div>");
        $(this.Element).wrap("<div class='input-group'></div>");
        this._$uploadForm = $("<form></form>");

        let uploadUrl: string = ko.unwrap(this.Config.Url);
        if (ko.unwrap(this.Config.AddAbsolutePath) !== false) {
            uploadUrl = window.absolutePath + uploadUrl;
        }

        this._$uploadForm.attr("target", iframeId).attr("action", uploadUrl).attr("method", "post").attr("name", "form_" + iframeId)
            .attr("enctype", "multipart/form-data").attr("encoding", "multipart/form-data").append(this._$fileupload).append($submitButton);

        var photoButtonEnabled = this.Config.PhotoButtonEnabled != undefined ? ko.unwrap(this.Config.MultiUpload) : true;

        $searchButton.append(this._$uploadForm);
        $(this.Element).parent().append($searchButton);
        if (photoButtonEnabled) {
            this._$photoButton = $('<span class="input-group-btn"><button class="btn btn-default"><span class="fal fa-camera"></span></button></span>');
            $(this.Element).parent().append(this._$photoButton);
            this._$photoButton.click(this.openEditPictureDialog);
        }
        $(this.Element).parent().append(this._$removeButton);

        this._$fileupload.bind("change propertychange", this._fileUploadChanged);
        this._$removeButton.click(this.RemoveClick);

        Bao.post("UploadSettings/GetMaxUploadSize").then((maxSize) => {
            this._maxUploadSize = maxSize;
        });

        if (ko.unwrap(this.Config.Upload) != null) {
            this.ViewModel[ko.unwrap(this.Config.Upload)] = this.UploadFn;
        }
    }

    private _fileUploadChanged = () => {
        // Subtracting 4KB from the maxUploadSize to create a buffer for the request size.
        // This is done to account for the case where the user tries to upload files that are almost or exactly maxUploadSize big 
        // and there's no space left for the rest of the request
        let fileSizeLimitExceeded = (Array.prototype.slice.call((<HTMLInputElement>this._$fileupload[0]).files)
            .map(file => file.size)
            .reduce((prev, next) => prev + next)) >= this._maxUploadSize - (this._maxUploadSize > 4096 ? 4096 : 0);

        if (fileSizeLimitExceeded) {
            let message = (this._messagesDictionary["msgMaxFileSize"]).replace('{0}', this.returnFileSize(this._maxUploadSize));
            (<HTMLInputElement>this._$fileupload[0]).files
            new BaoDialog(Bao.Session.ApplicationName, message, "info");
            this._uploadNeeded = false;
            this._$fileupload.val("");
            $(this.Element).val("");
            $(this.Element).change();
            return;
        }
        this._uploadNeeded = true;
        var currentFileNames = [];
        var fileName = "";
        if ((<HTMLInputElement>this._$fileupload[0]).files != null && (<HTMLInputElement>this._$fileupload[0]).files.length > 0) {
            fileName = "";
            $.each((<HTMLInputElement>this._$fileupload[0]).files, (index, value) => {

                fileName += value.name.substring(value.name.lastIndexOf('\\') + 1) + ";";
                currentFileNames.push(value.name);
            });
            fileName = fileName.slice(0, -1);
        } else if (this._$fileupload.val() != "") {
            fileName = (this._$fileupload.val() as string).substring((this._$fileupload.val() as string).lastIndexOf('\\') + 1);
        }
        if (ko.isObservable(this.FileNameObservable)) {
            if (this.FileNameObservable() == fileName) {
                this.FileNameObservable.valueHasMutated();
            } else {
                this.FileNameObservable(fileName);
            }
        }

        //Array mit den Dateinamen in das Observable Array zurückschreiben
        var fileNames = this.Config.SelectedFileNames;
        if (fileNames != undefined) {
            fileNames(currentFileNames);
        };

        this._isPictureUpload = false;
        $(this.Element).val(fileName);
        $(this.Element).change();
    }

    RemoveClick = () => {

        /* these statements are used here to show hide the download button when user delete the selected file using the delete icon which is placed next to the select file. */
        var baoConfig = ko.unwrap(this.Config);

        if (baoConfig && baoConfig.SelectedFileNames) {
            baoConfig.SelectedFileNames(null);
        }

        //Clean everything 
        this._uploadNeeded = false;
        this._$fileupload.val("");
        this._base64Image = null;
        this._isPictureUpload = false;
        $(this.Element).val("");
        $(this.Element).change();
    };

    UploadFn = () => {
        var q = $.Deferred();
        if ($(this.Element).val() != "" && (ko.unwrap(this.Config.Enabled) == null || ko.unwrap(this.Config.Enabled) == true) && this._uploadNeeded) {
            let uploadUrl: string = ko.unwrap(this.Config.Url);
            if (ko.unwrap(this.Config.AddAbsolutePath) !== false) {
                uploadUrl = window.absolutePath + uploadUrl;
            }

            if (this._isPictureUpload) {
                this._isPictureUpload = false;
                this._uploadNeeded = false;
                //Send the picture via Ajax
                $.ajax({
                    url: uploadUrl,
                    data: this._pictureFormData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    method: 'POST',
                    success: function (data) {
                        q.resolve(data);
                    },
                    error: function (data) {
                        q.reject(data);
                    }
                });
            } else {
                this._$uploadForm.attr("action", uploadUrl); //update url if changed e.g. by observable
                this._$iframe.unbind("load");
                this._$iframe.bind("load", (e) => {
                    this._uploadNeeded = false;
                    var multiUpload = this.Config.MultiUpload != undefined ? ko.unwrap(this.Config.MultiUpload) : false;
                    this._$fileupload.remove();
                    this._$fileupload = $("<input class='fakeupload' type='file' name='" + guid() + "' />").prop("multiple", multiUpload);;
                    this._$uploadForm.append(this._$fileupload);
                    this._$fileupload.bind("change propertychange", this._fileUploadChanged);
                    q.resolve("");
                });
                this._$uploadForm.submit();
            }
        } else {
            q.resolve();
        }
        return q.promise();
    };

    CheckEnable = () => {
        var _enabled = ko.unwrap(this.Config.Enabled);
        if (_enabled == null || _enabled == true) {
            $(this.Element).find(".input-group").show();
        } else {
            $(this.Element).find(".input-group").hide();
        }
    };


    dispose = () => {
        for (var i = 0; i < this._subscribes.length; i++) {
            this._subscribes[i].dispose();
        }
        $(this.Element).removeData(bindingName);

        this._$removeButton.unbind("click", this.RemoveClick);
        this._$fileupload.unbind("change propertychange", this._fileUploadChanged);
        this._$uploadForm.remove();
        this._$iframe.unbind("load");
        this._$iframe.remove();
    }

    openEditPictureDialog = () => {
        let takePictureDialog = new BaoDialog(Bao.Session.ApplicationName, takePictureDialogTemplate);
        takePictureDialog.ViewModel(new TakePictureDialog());
        takePictureDialog.Open();
        takePictureDialog.Buttons([
            new BaoDialog.ButtonFactory(takePictureDialog, Bao.Session.GetMessage("msgCancel"), () => {
                takePictureDialog.Close();
            }),
            new BaoDialog.ButtonFactory(takePictureDialog, Bao.Session.GetMessage("msgOk"), () => {
                var base64 = takePictureDialog.ViewModel().Canvas.toDataURL('image/jpeg', 1.0);
                this._base64Image = base64;
                takePictureDialog.Close();
                this.setPictureForUpload();
            })
        ]);
        takePictureDialog.ViewModel().InitDialog(this._base64Image ? this._base64Image : null);
    }

    setPictureForUpload = () => {
        this._isPictureUpload = true;
        this._uploadNeeded = true;
        var fileName = "IMG_" + moment().format(Bao.Utils.DateTimeFormat) + ".jpg";
        this._pictureFormData = new FormData();
        this._pictureFormData.append("file", new File([this.dataURItoBlob(this._base64Image)], fileName), fileName);

        var fileNames = this.Config.SelectedFileNames;
        if (fileNames != undefined) {
            fileNames([fileName]);
        };
        this._$fileupload.val("");
        $(this.Element).val(fileName);
        $(this.Element).change();
    }

    //Helper function for converting base64 to images
    private dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }

    // Helper function for converting file sizes in bytes to displayable formats
    private returnFileSize = (size) => {
        if (size < 1024) {
            return size + 'bytes';
        } else if (size >= 1024 && size < 1048576) {
            return (size / 1024).toFixed(1) + 'KB';
        } else if (size >= 1048576) {
            return (size / 1048576).toFixed(1) + 'MB';
        }
    }
}

var baoUploadBinding: KnockoutBindingHandler = {
    init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel) {
        var bindingInstance = new BaoUploadBinding(element, valueAccessor, allBindingsAccessor, viewModel);

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            bindingInstance.dispose();
        });
    }
};
ko.bindingHandlers[bindingName] = baoUploadBinding;